import {
  formatCurrency,
  formatDateTime,
  getTimezoneDate,
  timezones,
  capitalizeString,
} from '../../../../utilities/helpers'
import { getDisplayNetSales, getTransactionNet } from '../payoutReportTemplates'

export default function Transaction({ transaction }) {
  const isRefunded =
    String(transaction?.status || '').toLowerCase() === 'refunded'
  const timezone = timezones(
    transaction?.event?.venue?.timezone ||
      transaction?.flex_pack?.venue?.timezone
  )
  const netAmount = getTransactionNet(transaction)
  const hasPaymentPlan = Boolean(transaction?.payment_plan)
  const latestPaidInstallmentAmount = Array.isArray(
    transaction?.payment_plan?.installments
  )
    ? transaction.payment_plan.installments
        .map((installment, index) => ({ installment, index }))
        .filter(({ installment }) =>
          ['paid', 'complete'].includes(
            String(installment?.status || '').toLowerCase()
          )
        )
        .sort((a, b) => {
          const aTime = a.installment?.dueDate
            ? new Date(a.installment.dueDate).getTime()
            : Number.NEGATIVE_INFINITY
          const bTime = b.installment?.dueDate
            ? new Date(b.installment.dueDate).getTime()
            : Number.NEGATIVE_INFINITY
          if (aTime === bTime) return b.index - a.index
          return bTime - aTime
        })[0]?.installment?.amount
    : null
  const netSalesValue =
    typeof netAmount === 'number' && Number.isFinite(netAmount)
      ? getDisplayNetSales(transaction)
      : hasPaymentPlan && latestPaidInstallmentAmount !== null
        ? latestPaidInstallmentAmount
        : 0

  return (
    <tr
      className={`md-x md-x--scroll${
        isRefunded ? ' table-danger text-danger fw-bolder' : ''
      }`}
    >
      <td className="text-left">{transaction?.orderId}</td>
      <td className="text-left">
        {transaction?.processedAt ? (
          <span>
            <span>
              {formatDateTime(
                getTimezoneDate(transaction?.processedAt, timezone),
                'dateOnly'
              )}
            </span>
            <span className="mx-1">at</span>
            <span>
              {formatDateTime(
                getTimezoneDate(transaction?.processedAt, timezone),
                'timeOnly'
              )}
            </span>
          </span>
        ) : (
          'N/A'
        )}
      </td>
      <td className="text-left">{formatCurrency(netSalesValue)}</td>
      <td>
        {transaction?.intentDetails?.charges?.data[0]?.payment_method_details
          ?.card?.brand
          ? capitalizeString(
              transaction?.intentDetails?.charges?.data[0]
                ?.payment_method_details?.card?.brand
            )
          : 'N/A'}
      </td>
    </tr>
  )
}
